import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertZeroToEmpty',
    standalone: false
})
export class ConvertZeroToEmptyPipe implements PipeTransform {
  transform(value: string|number): string|number {
    return value === 0 ? '' : value;
  }
}
